import React, { useRef, useState } from "react";
import "../styles/Home.css";
import ExpertiseImg1 from "../resources/images/multi_family.jpeg";
import ExpertiseImg2 from "../resources/images/commercialoffice.jpeg";
import ExpertiseImg3 from "../resources/images/hospitality.jpeg";
import ExpertiseImg4 from "../resources/images/werehouse.jpeg";
import ExpertiseImg5 from "../resources/images/Healthcare.jpeg";
import ExpertiseImg6 from "../resources/images/school.jpeg";
import ExpertiseImg7 from "../resources/images/municipal.jpg";
import ExpertiseImg8 from "../resources/images/public_facilities2.jpg";
import ExpertiseImg9 from "../resources/images/energy_Industrial.jpeg";
import ExpertiseImg10 from "../resources/images/retail.jpeg";
import ExpertiseImg11 from "../resources/images/life_sciences_tech.jpeg";
import ExpertiseImg12 from "../resources/images/Environmental.jpeg";
import LogoName from "../resources/images/Name.svg";
import LeftArrow from "../resources/images/LeftArrow.svg";
import RightArrow from "../resources/images/RightArrow.svg";
import Craines from "../resources/images/Crains.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Autoplay, Navigation } from "swiper/modules";
import { motion } from "framer-motion";

const expertiseData = [
  {
    image: ExpertiseImg1,
    name: "Multifamily",
    position:
      "We specialize in Multifamily construction recruitment, connecting top talent with developers and contractors in the multifamily space. Our hiring solutions support ground-up apartment builds, renovations, affordable housing, senior living, and more.",
  },
  {
    image: ExpertiseImg2,
    name: "Commercial Office Space",
    position:
      "We specialize in Commercial Office Space recruitment, helping companies find professionals for office build-outs, tenant improvements, high-rises, and core & shell projects. We support teams building the future of workplace environments.",
  },
  {
    image: ExpertiseImg3,
    name: "Hospitality",
    position:
      "We specialize in Hospitality construction recruitment, sourcing top talent for hotel, resort, and restaurant projects. From boutique hotels to large-scale brand conversions, we provide professionals who deliver exceptional guest experiences.",
  },
  {
    image: ExpertiseImg4,
    name: "Warehouses & Manufacturing",
    position:
      "We specialize in Industrial and Warehouse recruitment, placing skilled professionals in projects ranging from cold storage and logistics hubs to manufacturing plants and cleanrooms. We support the growth of supply chains and production facilities.",
  },
  {
    image: ExpertiseImg5,
    name: "Healthcare",
    position:
      "We specialize in Healthcare construction recruitment, ensuring skilled professionals are placed on projects like hospitals, medical office buildings, surgical centers, and labs. Our network understands the critical demands of healthcare environments.",
  },
  {
    image: ExpertiseImg6,
    name: " Education (K–12 & Higher Ed)",
    position:
      "We recruit top talent for K–12 and Higher Education construction projects — from classrooms and campuses to labs, dorms, and athletic facilities. We help build the spaces where students thrive.",
  },
  {
    image: ExpertiseImg7,
    name: "Municipal",
    position:
      "We specialize in Municipal construction recruitment, helping local governments and contractors hire for civic buildings, public works, safety facilities, and libraries. We place talent that improves the communities they serve.",
  },
  {
    image: ExpertiseImg8,
    name: "Public Facilities",
    position:
      "We specialize in Public Facilities recruitment, placing professionals on projects like courthouses, correctional centers, military bases, and community hubs. We support government partners through skilled and compliant hiring solutions.",
  },
  {
    image: ExpertiseImg9,
    name: "Energy & Industrial",
    position:
      "We specialize in Energy & Industrial recruitment, sourcing professionals for power plants, refineries, renewable energy projects, and EV infrastructure. From fossil fuels to green tech, we power the industry with people.",
  },
  {
    image: ExpertiseImg10,
    name: "Retail",
    position:
      "We specialize in Retail construction recruitment, helping clients build out everything from flagship stores to shopping centers and QSR chains. Our candidates bring speed, quality, and brand consistency to every retail space.",
  },
  {
    image: ExpertiseImg11,
    name: "Life Sciences & Tech",
    position:
      "We specialize in Life Sciences & Tech construction recruitment, connecting companies with talent for lab facilities, cleanrooms, data centers, and R&D buildings. We understand the precision and compliance these projects demand.",
  },
  {
    image: ExpertiseImg12,
    name: "Environmental",
    position:
      "We specialize in Environmental construction recruitment, connecting skilled professionals with projects focused on sustainability, remediation, and conservation. From brownfield cleanups and waste treatment facilities to renewable infrastructure and green building initiatives, we help build a cleaner, greener future—one project at a time.",
  },
];

const OurExpertise = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <>
      <div className="our_expertise">
        <div className="logo_name">
          <img src={LogoName} alt={LogoName} />
        </div>
        <div className="craines">
          <img src={Craines} alt={Craines} />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="our_expertise_top">
                <motion.p
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ amount: 0.3 }}
                >
                  our Expertise
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
                  viewport={{ amount: 0.3 }}
                >
                  what we offer
                </motion.h5>
              </div>
              <div className="our_expertise_bottom">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  spaceBetween={30}
                  slidesPerView={1.3}
                  centeredSlides={true}
                  loop={true}
                  speed={800}
                  autoplay={{ delay: 7000, disableOnInteraction: false }}
                  navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                      centeredSlides: true,
                    },
                    767: {
                      slidesPerView: 1.3,
                      spaceBetween: 20,
                      centeredSlides: true,
                    },
                  }}
                  onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                >
                  {expertiseData.map((expertise, index) => (
                    <SwiperSlide key={index} className="expertise_slide">
                      <div
                        className="expertise_card"
                        style={{
                          backgroundImage: `url(${expertise.image})`,
                        }}
                      >
                        {activeIndex === index && (
                          <div className="client_des">
                            <h6>{expertise.name}</h6>
                            <p>{expertise.position}</p>
                          </div>
                        )}
                      </div>
                    </SwiperSlide>
                  ))}

                  {/* ✅ Custom Navigation Buttons with refs */}
                  <div className="swiper-button-prev" ref={prevRef}>
                    <img src={LeftArrow} alt="Prev" />
                  </div>
                  <div className="swiper-button-next" ref={nextRef}>
                    <img src={RightArrow} alt="Next" />
                  </div>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurExpertise;
